<template name="progress">
  <div class="progress-container">
    <div>
      <img class="progress-circle" :src="$client.loading" />
      <div class="loading-message">접속 정보를 확인 중 입니다</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    if (!this.$route.params.fromHome) return window.location.href = process.env.BASE_URL
  }
}
</script>

<style lang="scss">
  .progress-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    background-color: #00284c;
  }
  .progress-circle {
    width: 100px;
  }
</style>